import { render, staticRenderFns } from "./TwoFactAuth.vue?vue&type=template&id=805b253a&scoped=true"
import script from "./TwoFactAuth.vue?vue&type=script&lang=js"
export * from "./TwoFactAuth.vue?vue&type=script&lang=js"
import style0 from "./TwoFactAuth.vue?vue&type=style&index=0&id=805b253a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805b253a",
  null
  
)

export default component.exports